import { useEffect, useRef, useState } from "react";

function useAvailableHeight(offset = 0) {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>();

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver(() => {
      const rect = ref.current!.getBoundingClientRect();
      setHeight(window.innerHeight - rect.top - offset);
    });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [offset]);

  return { ref, height };
}

export default useAvailableHeight;
